import React from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Typography } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  item: {
    marginBottom: 22,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 6,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1F2937",
    wordBreak: "break-word",
  },
};

const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4}>
    <div style={styles.item}>
      <Typography style={styles.label}>
        {label}
      </Typography>

      <Typography style={styles.value}>
        {value || "NA"}
      </Typography>
    </div>
  </Grid>
);

const BankDetails = ({ bankDetails }) => {
  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Bank Details
      </Typography>

      <Grid container spacing={2}>
        <Field
          label="Account Number"
          value={bankDetails?.bankAccountNo}
        />

        <Field
          label="IFSC Code"
          value={bankDetails?.ifscCode}
        />

        <Field
          label="Bank Name"
          value={toCamelCase(bankDetails?.bankName)}
        />

        <Field
          label="Beneficiary Name"
          value={toCamelCase(bankDetails?.beneficiaryName)}
        />

        <Field
          label="Branch Name"
          value={toCamelCase(bankDetails?.branch)}
        />

        <Field
          label="Branch Address"
          value={toCamelCase(bankDetails?.branchAddress)}
        />

        <Field
          label="Match Score"
          value={
            bankDetails?.matchScore
              ? `${bankDetails.matchScore}%`
              : "NA"
          }
        />
      </Grid>
    </Paper>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

BankDetails.propTypes = {
  bankDetails: PropTypes.object,
};

export default BankDetails;